import {createFileRoute, redirect} from '@tanstack/react-router';

/** Legacy redirect: /profile/settings → /dashboard/settings. */
export const Route = createFileRoute('/profile/settings')({
  beforeLoad: () => {
    throw redirect({to: '/dashboard/settings'});
  },
});
